function addHr(Quill) {
	const Embed = Quill.import("blots/block/embed");
	
	class Hr extends Embed {}
	
	Hr.blotName = "divider";
	Hr.tagName = "hr";
	
	Quill.register("formats/divider", Hr);
}

export default addHr;


function handleHr(quill) {
	const range = quill.getSelection();
	if(range) {
		// insert the <hr> where the cursor is
		quill.insertEmbed(range.index, "divider", "null");
		
		if(!range.current || range.current.index === range.index) {
			quill.setSelection(range.index + 1, 0);
		}
	}
}

export { handleHr };
